<div class="modal-header">
    <div class="modal-title">{{title}}</div>

    <button id="add-interim-popup-close" type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <form #addInterimForm="ngForm" novalidate="novalidate" autocomplete="off">

        <div class="row mb-3">
            <div class="col-md-12 popup__datepicker">
                <div class="label">{{message}}</div>
               
                <app-custom-datepicker [minDateString]="reportService.getFYEDate('yyyy-M-d', true)" [maxDateString]="maxDate" 
                    [twoMonthMode]="true" [dateOutFormat]="'MMMM DD, YYYY'" [dateInFormat]="'YYYY-MM-DD'"
                    [dateValue]="newInterimDate" [disabled]="currentReport.isLocked"
                    [displayFormat]="'MMMM dd, yyyy'" placeholder="mm/dd/yyyy"
                    [(ngModel)]="newInterimDate" #NEW_INTERIM="ngModel" name="NEW_INTERIM"
                    [isInterimPopup]="true" required>
                </app-custom-datepicker>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button id="add-interim-popup-cancel" type="button" class="button secondary__button large__button position-static"
        (click)="cancel()">Cancel</button>
    <button id="add-interim-popup-add" type="button" class="button primary__button large__button position-static"
        [disabled]="!addInterimForm.valid" (click)="submit()">{{primaryButtonTitle}}</button>
</div>
